import { todayParis } from "../utils/calendar.mjs";
export function managerMetrics(state, filters = {}) {
  const matches = (c) =>
    (!filters.owner || c.ownerId === filters.owner) &&
    (!filters.agency || c.agency === filters.agency) &&
    (!filters.sector || c.sector === filters.sector) &&
    (!filters.source ||
      state.signals.some(
        (s) => s.clientId === c.id && s.source === filters.source,
      ));
  const clients = state.clients.filter(matches),
    ids = new Set(clients.map((c) => c.id));
  const inPeriod = (timestamp) => {
    if (!timestamp) return !filters.from && !filters.to;
    const date = todayParis(new Date(timestamp));
    return (
      (!filters.from || date >= filters.from) &&
      (!filters.to || date <= filters.to)
    );
  };
  const results = state.results.filter(
      (r) => ids.has(r.clientId) && inPeriod(r.createdAt),
    ),
    events = state.events.filter(
      (e) => ids.has(e.clientId) && inPeriod(e.createdAt),
    );
  const quotes = state.quotes.filter((q) => ids.has(q.clientId));
  const contacts = events.filter((e) => e.type === "contact_created").length,
    deciders = results.filter((r) => r.deciderJoined).length;
  const sentQuotes = quotes.filter((q) => q.sentAt && inPeriod(q.sentAt));
  const sent = sentQuotes.length,
    signed = quotes.filter((q) => q.signedAt && inPeriod(q.signedAt)).length;
  const converted = sentQuotes.filter((q) => q.signedAt).length;
  const pending = state.tasks.filter(
    (t) => ids.has(t.clientId) && !t.done && t.due_date_original < todayParis(),
  );
  const engagements = state.engagements.filter(
    (e) => ids.has(e.clientId) && !e.done && e.due < todayParis(),
  );
  const risk = clients.filter(
    (c) =>
      c.riskReason ||
      c.riskReasons?.length ||
      [
        "À RÉACTIVER",
        "À RECONQUÉRIR",
        "CLIENT DORMANT",
        "CLIENT PERDU",
      ].includes(c.status),
  );
  const riskCA = risk.reduce(
    (total, c) =>
      total +
      c.orders
        .filter((o) => inPeriod(o.date))
        .reduce((sum, o) => sum + Number(o.amount || 0), 0),
    0,
  );
  const recoveredCA = clients.reduce(
    (total, c) =>
      total +
      (c.reactivatedAt
        ? c.orders
            .filter(
              (o) => o.date >= c.reactivatedAt.slice(0, 10) && inPeriod(o.date),
            )
            .reduce((sum, o) => sum + Number(o.amount || 0), 0)
        : 0),
    0,
  );
  return {
    clients,
    results,
    events,
    pending,
    engagements,
    risk,
    activity: [
      ["Résultats d’appels saisis", results.length],
      ["Décideurs joints", deciders],
      ["Contacts créés", contacts],
      [
        "Plaquettes déclarées envoyées",
        events.filter((e) => e.type === "brochure_sent").length,
      ],
      ["Devis créés", quotes.filter((q) => inPeriod(q.createdAt)).length],
      ["Devis déclarés envoyés", sent],
      ["Actions en retard", pending.length],
      ["Engagements non tenus", engagements.length],
    ],
    outcomes: [
      [
        "Besoins détectés",
        state.needs.filter((n) => ids.has(n.clientId) && inPeriod(n.createdAt))
          .length,
      ],
      ["Devis signés", signed],
      [
        "Conversion en signature",
        sent ? `${Math.round((converted / sent) * 100)} %` : "—",
      ],
      [
        "Clients réactivés",
        new Set(
          events
            .filter((e) => e.type === "client_reactivated")
            .map((e) => e.clientId),
        ).size,
      ],
      ["CA récupéré connu", `${recoveredCA.toLocaleString("fr-FR")} €`],
      [
        "CA historique des clients à risque",
        `${riskCA.toLocaleString("fr-FR")} €`,
      ],
    ],
  };
}
